const state = {
  cityName: "",
  systemName: "",
  subName: "",
  token: null,
  tokenExpiresIn: "",
  accountInfo: null,
  accountName: "",
  accountId: "",
  roles: [],
  rolesModule: [],
  rolesCode: [],
};

if (!state.token && localStorage.auth_token) {
  state.token = localStorage.auth_token;
}
if (!state.tokenExpiresIn && localStorage.auth_tokenExpiresIn) {
  state.tokenExpiresIn = localStorage.auth_tokenExpiresIn;
}
if (!state.accountInfo && localStorage.auth_accountInfo) {
  state.accountInfo = JSON.parse(localStorage.auth_accountInfo);
}
if (!state.accountName && localStorage.auth_accountName) {
  state.accountName = localStorage.auth_accountName;
}
if (!state.accountId && localStorage.auth_accountId) {
  state.accountId = localStorage.auth_accountId;
}

const getters = {
  getCityName: (state) => state.cityName,
  getSystemName: (state) => state.systemName,
  getSubName: (state) => state.subName,
  getToken: (state) => state.token,
  getTokenExpiresIn: (state) => state.tokenExpiresIn,
  getAccountInfo: (state) => state.accountInfo,
  getAccountId: (state) => state.accountId,
  getAccountName: (state) => state.accountName,
  getRolesModule: (state) => state.rolesModule,
  getRolesCode: (state) => state.rolesCode,
};

const mutations = {
  setCityName(state, value) {
    state.cityName = value;
  },
  setSystemName(state, value) {
    state.systemName = value;
  },
  setSubName(state, value) {
    state.subName = value;
  },
  setToken(state, value) {
    state.token = value;
    localStorage.auth_token = value;
  },
  setTokenExpiresIn(state, value) {
    state.tokenExpiresIn = value;
    localStorage.auth_tokenExpiresIn = value;
  },
  setAccountInfo(state, value) {
    state.accountInfo = value;
    localStorage.auth_accountInfo = JSON.stringify(value);
    state.accountId = value.id;
    localStorage.auth_accountId = value.id;
    state.accountName = value.account;
    localStorage.auth_accountName = value.account;
  },
  setRoles(state, value) {
    state.roles = value;
    let moduleIds = [];
    let modules = [];
    let codes = [];
    value.forEach((d) => {
      if (d.permissions) {
        d.permissions.forEach((m) => {
          if (!moduleIds.includes(m.id)) {
            moduleIds.push(m.id);
            modules.push(m);
            codes.push(m.code);
          }
        });
      }
    });
    state.rolesModule = modules;
    state.rolesCode = codes;
  },
};

export default {
  state,
  getters,
  mutations,
};
